export const WEBMERGE_DOCUMENT_REFERRAL_AGREEMENT_ID = '823439';
export const WEBMERGE_DOCUMENT_REFERRAL_AGREEMENT_KEY = 'zzwxrh';
export const WEBMERGE_DOCUMENT_LANDLORD_LISTING_AGREEMENT_ID = '834858';
export const WEBMERGE_DOCUMENT_LANDLORD_LISTING_AGREEMENT_KEY = 'vc1hm6';
export const WEBMERGE_TEMPLATE_GROUP_ID_TAR = 1;

export const WEBMERGE_DOCUMENT_FIELDS = {
  [WEBMERGE_DOCUMENT_REFERRAL_AGREEMENT_ID]: [
    {
      name: 'commissionPercentage',
      key: '11036579a82fa073d63cf8c6bd5c0f46',
    },
    {
      name: 'partnerFullName',
      key: '131d55d8a84aea2913044f5a9c83b678',
    },
    {
      name: 'partnerSignedDate',
      key: '1ef23630b017c36ab665aa02306e1ce2',
    },
    {
      name: 'sunroomSignedDate',
      key: '6d5aa7f607432188facdd8d4534d73b9',
    },
    {
      name: 'partnerSignatureImgUrl',
      key: 'b3cfd67cd630e17b0a3f351f4ecb0a8b',
    },
  ],
  [WEBMERGE_DOCUMENT_LANDLORD_LISTING_AGREEMENT_ID]: [
    {
      key: '884d9804999fc47a3c2694e49ad2536a',
      name: 'address',
    },
    {
      key: '4cf68d99b7f3b23b24dace9fb98d8969',
      name: 'landlordName',
    },
    {
      key: 'ffb890247411bd0b647ebb352a2148bd',
      name: 'landlordEmail',
    },
    {
      key: '7abf9e3172d851928729da4ad3af9e63',
      name: 'landlordPhone',
    },
    {
      key: '2e47c62f8a3134226e1713e62f9d76d1',
      name: 'termBegins',
    },
    {
      key: '2fbf858aea528e022a745cebee4978b1',
      name: 'commission',
    },
    {
      key: 'b66c178dcc7adc123c3eb4539f4b951d',
      name: 'landlordNameBottom',
    },
    {
      key: '575342bbd2ce7dfb60fbb23a74a1efef',
      name: 'signedDateLandlord',
    },
    {
      key: 'ab5e3065837143fccb8a3f4c0badcb93',
      name: 'signedDateBroker',
    },
    {
      key: '3d85745f037c159f2eaa527ca9d13305',
      name: 'userImageSignatureUrl',
    },
  ],
};

export function getWebmergeDocumentFields({ documentId, documentFields }) {
  const documentFieldDefinitions = WEBMERGE_DOCUMENT_FIELDS[documentId];
  if (!documentFieldDefinitions) {
    return null;
  }
  return documentFieldDefinitions.reduce(
    (memo, fieldDef) => ({
      ...memo,
      [fieldDef.key]:
        typeof documentFields[fieldDef.name] === 'number'
          ? documentFields[fieldDef.name]
          : documentFields[fieldDef.name] || '',
    }),
    {},
  );
}
